/**
 * ResultListPage Component
 */

import './styles.scss';

import * as classNames from 'classnames';
import { random } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { getResponsiveAssets } from '../../../../utils/image';
import CollectionCard from '../../../molecules/media/CollectionCard';
import TrackListItem from '../../../molecules/search/TrackListItem';

interface IOwnProps {
  collection?: GQL.ICollection | null;
  gridSize: CardSize;
  pageNumber: number;
  results: GQL.ITrackSearchResultEdge[];
}

export type ResultListPageProps = IOwnProps;

const collectionCardPositionLayouts = 4;

class ResultListPage extends React.Component<IOwnProps> {
  private collectionCardPositionLayout: number;

  constructor(props) {
    super(props);

    this.collectionCardPositionLayout = random(1, collectionCardPositionLayouts);
  }

  shouldComponentUpdate() {
    return false; // why?
  }

  render() {
    const {
      collection,
      gridSize,
      results,
    } = this.props;

    const classes = new BEM('result-list-page');

    const extraClasses = classNames(
      `grid--${gridSize}`,
      !collection && 'without--collection',
      collection && `collection-card-position--${this.collectionCardPositionLayout}`,
    );

    return (
      <section {...classes('', '', extraClasses) }>
        <ul {...classes('list') }>
          {results.map(({ node }, i) =>
            <TrackListItem
              actionSource="search_results_list"
              key={node!.id}
              className="result-list-item"
              track={node!}
              cardProps={{
                backgroundColor: gridSize !== 'xlarge' ? 'white' : 'bw3',
                size: gridSize,
              }}
            />,
          )}
        </ul>
        {collection && (
          <div {...classes('collection-card') }>
            <CollectionCard
              image={getResponsiveAssets('cover', collection.assets!)}
              subtitle={collection.category ? collection.category.name! : 'Collection'}
              title={collection.name}
              slug={collection.slug!}
              topic="Collection related to your search"
            />
          </div>
        )}
      </section>
    );
  }
}

export default ResultListPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/search/ResultListPage/index.tsx